const BASE = (import.meta.env.BASE_URL || '/').replace(/\/+$/, '');

export function basePath(path: string): string {
  return `${BASE}${path.startsWith('/') ? path : `/${path}`}`;
}
